import React from "react";
import { PaymentLayout as Layout } from "../shared/Layout";
import { useAppTranslation } from "../../../i18n/useAppTranslation";
import { CrossCircleIcon } from "../../../assets/Icons/CrossCircleIcon";

export function PaymentFailure() {
  const { tCommon: t } = useAppTranslation.Common();

  return (
    <Layout>
      <Layout.Icon type="failure">
        <CrossCircleIcon />
      </Layout.Icon>
      <h2>{t("payment.failure.title")}</h2>
      <Layout.Description>
        <p>{t("payment.failure.message1")}</p>
        <p>{t("payment.failure.message2")}</p>
      </Layout.Description>
    </Layout>
  );
}
